import { AccommodationDashboardStats } from '@/renderer/types/accommodation';
import React from 'react';

interface Props {
  stats: AccommodationDashboardStats | null;
  isLoading: boolean;
}

const CHIPS = [
  {
    key: 'pending_bookings' as const,
    label: 'Pending',
    color: 'text-amber-700 bg-amber-50',
  },
  {
    key: 'confirmed_bookings' as const,
    label: 'Confirmed',
    color: 'text-pos-primary bg-pos-primary/10',
  },
  {
    key: 'checked_in' as const,
    label: 'Checked in',
    color: 'text-pos-secondary bg-pos-primary/10',
  },
] as const;

interface AvgNightsChip {
  label: string;
  color: string;
}

const AVG_CHIP: AvgNightsChip = {
  label: 'Avg stay',
  color: 'text-gray-600 bg-gray-100',
};

export const StatusSummaryChips: React.FC<Props> = ({ stats, isLoading }) => (
  <div className="grid gap-3 sm:grid-cols-4">
    {CHIPS.map((chip) => (
      <div
        key={chip.key}
        className={`flex flex-col items-center rounded-2xl px-4 py-3 ${chip.color}`}
      >
        <p className="text-lg font-bold">
          {isLoading ? '–' : (stats?.[chip.key] ?? 0)}
        </p>
        <p className="text-[10px] opacity-70">{chip.label}</p>
      </div>
    ))}
    <div
      className={`flex flex-col items-center rounded-2xl px-4 py-3 ${AVG_CHIP.color}`}
    >
      <p className="text-lg font-bold">
        {isLoading ? '–' : `${(stats?.avg_nights ?? 0).toFixed(1)}n`}
      </p>
      <p className="text-[10px] opacity-70">{AVG_CHIP.label}</p>
    </div>
  </div>
);
